import React, { useState, useRef, useEffect } from "react";
import axiosSmartSurvey from "../../api/axios";
import { Box, Button, Stack, Card, CardContent, Typography, TextField, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import useTrackDoc from "./hooks/useTrackDoc";
import moment from 'moment'
import 'moment/locale/th'
// ICON

const SearchLandDoc = () => {
  const [code, setCode] = useState("");
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState("");
  const inputRef = useRef(null); // ✅ useRef สำหรับโฟกัสช่องกรอก

  //Custom Hooks
  const { fetchSingleFolderData } = useTrackDoc()

  const handleSearch = async (e) => {
    e.preventDefault()
    if (!code.trim()) return;
    await fetchSingleFolderData(code, setDoc, setOpenError, setErrorText)
    setCode("")
  };
  // Alert
  const [openError, setOpenError] = useState(false)
  const handleErrorAlertClose = () => {
    setOpenError(false);
    setErrorText('')
  }
  const [errorText, setErrorText] = useState('')
  // 

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [])
  useEffect(() => {
    console.log(doc)
  }, [doc])

  return (
    <Box className='otherSide' id="otherSide">
      <Box className='surveyLayouts' id="surveyLayouts"></Box>
      {/* Alert */}
      <Snackbar
        open={openError}
        autoHideDuration={3000}
        onClose={handleErrorAlertClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <Alert variant="filled" severity="error" sx={{ width: '100%' }}>
          {errorText}
        </Alert>
      </Snackbar>
      {/*  */}
      <Card
        sx={{
          border: ' grey',
          background: '#fafaeb',
          m: 2,
          width: '60%',
        }}>
        <CardContent >
          <Typography variant="h5" align="center" gutterBottom>
            ค้นหาซองเอกสารที่ดิน
          </Typography>
        </CardContent>

        <CardContent>
          <Box
            mb={2}
            component="form"
            onSubmit={handleSearch}
            align="center"
          >
            <TextField
              inputRef={inputRef}
              label="ยิงบาร์โค้ด หรือพิมพ์รหัสแปลง (เช่น 01A001/001)"
              value={code}
              sx={{ width: '300px' }}
              onChange={(e) => {
                setCode(e.target.value.toUpperCase())
              }}
              variant="outlined"
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleSearch}
              type="submit"
              sx={{ ml: 1, fontSize: '1.1rem', py: 1.5 }}
            >
              🔍 ค้นหา
            </Button>
          </Box>
        </CardContent>
        {doc && (

          <CardContent >
            <Typography variant="h6" gutterBottom>
              📄 ข้อมูลซอง
            </Typography>

            <Stack spacing={1}>
              {/* <Typography><strong>Gid:</strong> {doc.gid}</Typography> */}
              <Typography><strong>รหัสแปลงที่ดินใหม่:</strong> {doc.parcelCode}</Typography>
              <Typography><strong>รหัสแปลงที่ดินเก่า:</strong> {doc.oldParcel}</Typography>
              <Typography><strong>เลขเอกสารสิทธิ์ที่ดิน:</strong> {doc.dn}</Typography>
              <Typography><strong>ประเภทเอกสารสิทธิ์ที่ดิน:</strong> {doc.parcelTypeName || "-"}</Typography>
              <Typography><strong>ชื่อผู้ถือซอง:</strong> {doc.holder == 0 ? 'ห้องซอง' : doc.fname + ' ' + doc.lname || "-"}</Typography>
              <Typography><strong>ตั้งแต่วันที่:</strong> {moment(doc.recievedDate).add(543, 'year').format('วันที่ DD MMMM YYYY เวลา HH:mm:ss') || "-"}</Typography>
            </Stack>
          </CardContent>
        )}
        <CardContent align="center">
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              window.open(`/trackdoc/print?parcelCode=${encodeURIComponent(doc.parcelCode)}&oldParcel=${encodeURIComponent(doc.oldParcel)}`, '_blank');
              if (inputRef.current) {
                inputRef.current.focus();
              }
            }}
            sx={{ fontSize: '1.1rem', py: 1.5 }}

          >
            🖨️ พิมพ์บาร์โค้ด
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SearchLandDoc;
